import graphQLClient from '../graphql-client';
import { VERIFY_SHIPPING_ADDRESS } from '../graphql';
import {
  IshipAddres,
  ShippingAddressVerificationResult,
} from '../components/interfaces';

export const verifyShippingAddress = async (
  data: Partial<IshipAddres>
): Promise<ShippingAddressVerificationResult> => {
  try {
    const response = await graphQLClient.request<{
      verifyShippingAddress: ShippingAddressVerificationResult;
    }>(VERIFY_SHIPPING_ADDRESS, {
      input: {
        addressLine1: String(data.addressLine1 || ''),
        city: data.city || undefined,
        province: data.province || undefined,
        postcode: data.postcode || undefined,
        country: data.country || undefined,
      },
    });

    return response.verifyShippingAddress;
  } catch {
    return {
      ok: true,
    };
  }
};
